import React from 'react'

function Shipping() {
  return (
    <div className="legal-page">
        <h5>Last update on Aug 1 2025</h5>
            <p>Shipping is not applicable for business
        </p>
    </div>
  )
}

export default Shipping